import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import escapeKey from '../../escape-key';
import cursor, { cursors, animationFrame } from '../../cursor';
import { scroll } from '../../scroll-to';

const CLASS = 'fs-video_playing';
const html = document.documentElement;

export default function (el) {
  // const button = el.querySelector('[data-fsv-button]');
  const video = el.querySelector('[data-fsv-video]');
  if (!window.isMobile.any) {
    video.play();
  }
  let playing = false;
  function toggle(_playing) {
    playing = _playing;
    video.currentTime = 0;
    video.muted = !playing;
    video.play();
    el.classList.toggle(CLASS);
    cursor.setBgImage(playing ? cursors.CLOSE : cursors.PLAY);
    if (playing) {
      const scrollSection = el.closest('[data-scroll-section]');
      scroll(scrollSection.offsetTop);
      // disableBodyScroll(el);
      if (window.isMobile.any) {
        cursor.setPosition(html.clientWidth - 50, 50);
        cursor.toggle(true);
        animationFrame();
        el.style.zIndex = 4;
      }
    } else {
      // enableBodyScroll(el);
      if (window.isMobile.any) {
        cursor.toggle(false);
        animationFrame();
        el.style.zIndex = '';
      }
    }
  }
  el.addEventListener('click', () => {
    toggle(!playing);
  });
  if (!window.isMobile.any) {
    el.addEventListener('mouseenter', (e) => {
      cursor.setBgImage(playing ? cursors.CLOSE : cursors.PLAY);
      cursor.setPosition(e.x, e.y);
      cursor.toggle(true);
    });
    el.addEventListener('mouseleave', () => {
      cursor.toggle(false);
    });
    el.addEventListener('mousemove', (e) => {
      cursor.setPosition(e.x, e.y);
    });
  } else {
    window.addEventListener('resize', () => {
      if (playing) {
        cursor.setPosition(html.clientWidth - 50, 50);
      }
    });
  }
  escapeKey(() => toggle(false));
}
